/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

/** UpdateUserSettingRequest — dark-roast DTO: UserSettingDTO */
export const updateUserSettingRequestSchema = z.object({ "name": z.string().nullish(), "value": z.string().nullish() });
export type UpdateUserSettingRequest = z.infer<typeof updateUserSettingRequestSchema>;
